import React from "react";

const EnamadBadge: React.FC = () => {
  return (
    <a
      referrerPolicy="origin"
      target="_blank"
      href="https://trustseal.enamad.ir/?id=673902&Code=jGxUzLyI3ydVdQrK2vfRUASGpLencnMZ"
      style={{ display: "block", width: "100%", height: "100%" }}
    >
       <img
        referrerPolicy="origin"
        src="https://trustseal.enamad.ir/logo.aspx?id=673902&Code=jGxUzLyI3ydVdQrK2vfRUASGpLencnMZ"
        alt="نماد اعتماد الکترونیکی"
        style={{ cursor: "pointer", width: "100%", height: "100%" }}
        code="jGxUzLyI3ydVdQrK2vfRUASGpLencnMZ"
      />
    </a>
  );
};

export default EnamadBadge;
